// extracted by mini-css-extract-plugin
export var mobile = "projects-template-mobile-module--mobile--18IRC";
export var image = "projects-template-mobile-module--image--1uA4y";
export var orderName = "projects-template-mobile-module--orderName--2dI7k";